import { render, staticRenderFns } from "./CompanyBackupEdit.vue?vue&type=template&id=560f1926&scoped=true&"
import script from "./CompanyBackupEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyBackupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f1926",
  null
  
)

export default component.exports